import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=d7b560ea&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7b560ea')) {
      api.createRecord('d7b560ea', component.options)
    } else {
      api.reload('d7b560ea', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=d7b560ea&", function () {
      api.rerender('d7b560ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CP8egDHABi0B/JS/comp/FavElement.vue"
export default component.exports